<button
  class="btn"
  [ngClass]="action"
  [disabled]="disabled"
  (click)="onClick()"
  [attr.aria-label]="ariaLabel">
  <i class="fa-regular icon" [ngClass]="icon" aria-hidden="true"></i>
</button>